module.exports = __webpack_public_path__ + "static/techkid-circle.aac578e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/techkid-circle.jpg
// module id = 362
// module chunks = 35783957827783